// ============= PLANNING HELPERS =============

// Helper: parse date string as LOCAL time (prevents UTC timezone shift)
function localDate(dateStr) {
  if (!dateStr) return new Date();
  if (typeof dateStr === 'string' && dateStr.length === 10) {
    return new Date(dateStr + 'T12:00:00'); // noon local to avoid any day boundary issues
  }
  return new Date(dateStr);
}

export function weekDates(date) {
  const d = localDate(date);
  const day = d.getDay(); // 0=Sun, 1=Mon...
  // US format: week starts on Sunday, work week Mon-Sat
  const diff = d.getDate() - day;
  const sun = new Date(d);
  sun.setDate(diff);
  return Array.from({ length: 6 }, (_, i) => {
    const dt = new Date(sun);
    dt.setDate(sun.getDate() + i + 1); // Mon-Sat (skip Sunday for work week)
    return dt.toISOString().split('T')[0];
  });
}

export function monthDates(date) {
  const d = localDate(date);
  const y = d.getFullYear(), m = d.getMonth();
  const first = new Date(y, m, 1), last = new Date(y, m + 1, 0);
  const dates = [];
  // US format: pad from Sunday (getDay() 0=Sun)
  const pad = first.getDay();
  for (let i = pad; i > 0; i--) {
    const pd = new Date(first); pd.setDate(pd.getDate() - i);
    dates.push({ date: pd.toISOString().split('T')[0], cur: false });
  }
  for (let i = 1; i <= last.getDate(); i++)
    dates.push({ date: new Date(y, m, i).toISOString().split('T')[0], cur: true });
  while (dates.length % 7 !== 0) {
    const ld = new Date(last); ld.setDate(ld.getDate() + dates.length - pad - last.getDate() + 1);
    dates.push({ date: ld.toISOString().split('T')[0], cur: false });
  }
  return dates;
}

export function fmtDate(s) {
  return new Date(s + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

export function fmtDay(s) {
  return new Date(s + 'T00:00:00').getDate();
}

export function getISOWeek(dateStr) {
  const d = localDate(dateStr);
  const tmp = new Date(d.valueOf());
  tmp.setDate(tmp.getDate() + 3 - ((tmp.getDay() + 6) % 7));
  const week1 = new Date(tmp.getFullYear(), 0, 4);
  return 1 + Math.round(((tmp - week1) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);
}

export const DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const STATUS_COLORS = {
  planned: 'bg-blue-100 text-blue-700 border-blue-200',
  in_progress: 'bg-amber-100 text-amber-700 border-amber-200',
  completed: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  rescheduled: 'bg-purple-100 text-purple-700 border-purple-200',
  delayed: 'bg-red-100 text-red-700 border-red-200',
};

export async function exportToExcel(plans, dateRange) {
  const headers = ['Date', 'Line', 'Project', 'SR#', 'Category', 'Material', 'Job#', 'Unit', 'Planned', 'Completed', 'Shipped', 'Status', 'Notes'];
  const rows = plans.map(p => [
    p.date, p.line_name, p.project_name, '', p.category_name,
    p.material_description || '', p.job_number || '', p.planning_unit,
    p.planned_quantity, p.completed_quantity, p.shipped_quantity, p.status, p.notes || ''
  ]);

  let csv = '\uFEFF';
  csv += headers.join(',') + '\n';
  rows.forEach(r => {
    csv += r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(',') + '\n';
  });

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `production_plan_${dateRange[0]}_${dateRange[dateRange.length - 1]}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
